import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      border-top: ", ";\n      border-color: ", ";\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  align-items: center;\n  z-index: ", ";\n  ", "\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: ", ";\n  box-shadow: ", ";\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  border-color: ", ";\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  cursor: pointer;\n  z-index: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      border-bottom: ", ";\n      border-color: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  ", "\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow-y: auto;\n  background-color: ", ";\n  z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { forwardRef, useEffect, useContext } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import { border, color, shadow, typography } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import { Portal } from '../portal/Portal';
import { Icon } from '../icon/Icon';
import { Button } from '../button/Button';
import { Box, Flex } from '../grid/Grid';
import { Heading } from '../heading/Heading';
var Mask = styled(Box)(_templateObject(), themeGet('colors.blacks.5'), themeGet('zIndex.modalMask'));
var Header = styled(Flex)(_templateObject2(), typography, function (props) {
  return props.divider && css(_templateObject3(), themeGet('modal.header.borderBottom'), themeGet('modal.header.borderColor'));
});
var CloseButton = styled(Button).attrs({
  variant: 'link'
})(_templateObject4(), themeGet('modal.closeButton.top'), themeGet('modal.closeButton.right'), themeGet('modal.closeButton.size'), themeGet('modal.closeButton.size'), themeGet('modal.closeButton.backgroundColor'), themeGet('modal.closeButton.borderRadius'), themeGet('zIndex.fixed'));
var CloseButtonIcon = styled(Icon).attrs({
  name: 'CLOSE',
  color: 'blacks.3'
})(_templateObject5(), themeGet('modal.closeButton.size'), themeGet('modal.closeButton.size'), themeGet('modal.closeButton.color'));
var Content = styled(Box)(_templateObject6(), themeGet('zIndex.modal'), themeGet('modal.content.boxShadow'), themeGet('modal.content.backgroundColor'), themeGet('modal.content.border'), themeGet('modal.content.borderRadius'), themeGet('modal.content.borderColor'), border);
var Body = styled(Box)(_templateObject7(), color);
var Footer = styled(Flex)(_templateObject8(), themeGet('zIndex.fixed'), shadow, function (props) {
  return props.divider && css(_templateObject9(), themeGet('modal.footer.borderTop'), themeGet('modal.footer.borderColor'));
});
export var Modal =
/*#__PURE__*/
forwardRef(function Modal(_ref, ref) {
  var children = _ref.children,
      show = _ref.show,
      closeButton = _ref.closeButton,
      onClose = _ref.onClose,
      _ref$maskClosable = _ref.maskClosable,
      maskClosable = _ref$maskClosable === void 0 ? true : _ref$maskClosable,
      props = _objectWithoutProperties(_ref, ["children", "show", "closeButton", "onClose", "maskClosable"]);

  useEffect(function () {
    show ? disableBodyScroll() : clearAllBodyScrollLocks();
  }, [show]);

  var _useContext = useContext(ThemeContext),
      defaultContentStyle = _useContext.modal.content;

  return show &&
  /*#__PURE__*/
  React.createElement(Portal, null,
  /*#__PURE__*/
  React.createElement(Mask, {
    onClick: maskClosable && onClose
  },
  /*#__PURE__*/
  React.createElement(Content, _extends({
    ref: ref
  }, defaultContentStyle, props, {
    onClick: function onClick(event) {
      return event.stopPropagation();
    }
  }),
  /*#__PURE__*/
  React.isValidElement(closeButton) ? closeButton : closeButton &&
  /*#__PURE__*/
  React.createElement(CloseButton, {
    variant: "link",
    onClick: onClose
  },
  /*#__PURE__*/
  React.createElement(CloseButtonIcon, null)), children)));
});
export var ModalHeader =
/*#__PURE__*/
forwardRef(function ModalHeader(_ref2, ref) {
  var children = _ref2.children,
      _ref2$divider = _ref2.divider,
      divider = _ref2$divider === void 0 ? true : _ref2$divider,
      fontSize = _ref2.fontSize,
      props = _objectWithoutProperties(_ref2, ["children", "divider", "fontSize"]);

  var _useContext2 = useContext(ThemeContext),
      defaultHeaderStyle = _useContext2.modal.header;

  var defaultFontSize = defaultHeaderStyle.heading.fontSize;
  return (
    /*#__PURE__*/
    React.createElement(Header, _extends({
      divider: divider
    }, defaultHeaderStyle, props, {
      ref: ref
    }),
    /*#__PURE__*/
    React.createElement(Heading, {
      as: "div",
      width: 1,
      fontSize: fontSize || defaultFontSize
    }, children))
  );
});
export var ModalBody =
/*#__PURE__*/
forwardRef(function ModalBody(_ref3, ref) {
  var props = _extends({}, _ref3);

  var _useContext3 = useContext(ThemeContext),
      defaultBodyStyle = _useContext3.modal.body;

  return (
    /*#__PURE__*/
    React.createElement(Body, _extends({
      ref: ref
    }, defaultBodyStyle, props))
  );
});
export var ModalFooter =
/*#__PURE__*/
forwardRef(function ModalFooter(_ref4, ref) {
  var _ref4$divider = _ref4.divider,
      divider = _ref4$divider === void 0 ? false : _ref4$divider,
      props = _objectWithoutProperties(_ref4, ["divider"]);

  var _useContext4 = useContext(ThemeContext),
      defaultFooterStyle = _useContext4.modal.footer;

  return (
    /*#__PURE__*/
    React.createElement(Footer, _extends({
      divider: divider,
      ref: ref,
      as: "footer"
    }, defaultFooterStyle, props))
  );
});